import {createElement, Component, PropTypes} from 'rlink-react';

import {elementOf} from 'rlink-utils/RlinkPropTypes';

export default class FormComponent extends Component {
  constructor (props) {
    super(props);
    this._inputProps = {};
    this.inputs = new Set();
  }

  componentWillUpdate () {
    // clear input props cache whenever we update for whatever reason
    this._inputProps = {};
  }
  get formName () {
    return this.props.formName;
  }

  getSubmitData () {
    let params = {};
    for (let name in this.props.fieldData) {
      params[name] = this.props.fieldData[name].value;
    }
    return params;
  }

  isValid () {
    for (let fieldName in this.props.fieldData) {
      if ('valid' in this.props.fieldData[fieldName]
        && this.props.fieldData[fieldName].valid === false) {
        return false;
      }
    }
    return true;
  }

  validateAll () {
    let isValid = true;
    for (let input of this.inputs) {
      let {valid} = input.validate();
      if (!valid) {
        isValid = false;
      }
    }
    return isValid;
  }

  validationProblemsForField (field) {
    return field.validationProblems || [];
  }

  renderFormProblems () {
    if (this.props.formProblems && this.props.formProblems.length) {
      return <ul className="form-error">
        {this.props.formProblems.map(
          (problem, idx) => <li key={idx} className="form-problem">{problem}</li>)}
      </ul>;
    }
  }

  getChildContext () {
    return {
      rlinkForm: this,
    };
  }


  inputProps (fieldName) {
    if (!(fieldName in this._inputProps)) {
      let field = this.props.fieldData[fieldName] || {};
      this._inputProps[fieldName] = {
        ref: input => {
          if (input) {
            this.inputs.add(input);
          } else {
            this.inputs = new Set(Array.from(this.inputs).filter(
              existingInput => !existingInput._inputWillUnmount));
          }
        },
        fieldName,
        value: field.value,
        committedValue: field.committedValue,
        loc: this.props.loc,
        disabled: field.disabled,
        changes: field.changes,
        validationProblems: this.validationProblemsForField(field),
        onChange: ev => {
          let value;
          if ('value' in ev) {
            value = ev.value;
          } else {
            value = ev.target.value;
          }
          if (this.props.onUpdateFieldValue) {
            this.props.onUpdateFieldValue({
              form: this.formName,
              field: fieldName,
              value,
            });
          }

        },
        onChangeDidCommit: ev => {
          if (this.props.onCommitFieldValue) {
            this.props.onCommitFieldValue({
              form: this.formName,
              field: fieldName,
              value: ev.value,
              rawValue: ev.rawValue,
              changes: ev.changes,
            });
          }
        },
        onValidate: ev => {
          if (this.props.onFieldWasValidated) {
            this.props.onFieldWasValidated({
              form: this.formName,
              field: fieldName,
              value: ev.value,
              problems: ev.problems,
              valid: ev.valid,
            });
          }
        },
      };
    }
    return this._inputProps[fieldName];
  }
}


FormComponent.propTypes = {
  formName: PropTypes.string.isRequired,
  fieldData: PropTypes.objectOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.any,
      changes: PropTypes.arrayOf(
        PropTypes.array),
      committedValue: PropTypes.any,
      disabled: PropTypes.bool,
      valid: PropTypes.bool,
      validationProblems: PropTypes.arrayOf(
        PropTypes.node),
    })
  ).isRequired,
  formProblems: PropTypes.arrayOf(PropTypes.node),
  onUpdateFieldValue: PropTypes.func,
  onCommitFieldValue: PropTypes.func,
  onFieldWasValidated: PropTypes.func,
};


FormComponent.childContextTypes = {
  rlinkForm: elementOf(FormComponent),
};



// WEBPACK FOOTER //
// ./lib/rlink-forms/redux/FormComponent.jsx